<script lang="ts">
  import { cn } from "$lib/utils";
  import PageNumber from "./page-number.svelte";
  export let pages: number;
  export let pageIndex: number;
  export let urlStart: string;
  export let firstPageUrl = "";
  export let hasBorder = true;

  $: prevUrl = `${urlStart}/${pageIndex - 1}`;
  $: nextUrl = `${urlStart}/${pageIndex + 1}`;
</script>

{#if pages > 1}
  <div
    class={cn(
      "mx-auto mb-20 flex max-w-5xl items-center justify-between gap-4 px-4 lg:px-0",
      hasBorder && "mt-12 border-t border-blog-gray-200 pb-24 pt-6",
    )}
  >
    <div class="w-[7.125rem]">
      {#if pageIndex > 1}
        <a
          href={prevUrl}
          class={cn(
            "cursor-pointer rounded-md border border-blog-gray-300 px-3 py-2 text-blog-gray-500 dark:text-blog-gray-400",
            "block text-blog-gray-800",
          )}
          aria-label="Previous page"
        >
          ←&nbsp;Previous</a
        >
      {/if}
    </div>

    <!-- mobile layout -->
    <div class="flex justify-center gap-4 lg:hidden">
      <span>{pageIndex} / {pages}</span>
    </div>

    <!-- desktop layout -->
    <div class="hidden lg:flex lg:justify-center lg:gap-4">
      <PageNumber href={firstPageUrl || urlStart} index={1} isActive={pageIndex === 1} />

      {#if pageIndex > 3}
        <span class="flex h-10 w-10 items-center justify-center">...</span>
      {/if}

      {#if pageIndex > 1 && pageIndex < pages}
        <PageNumber href={`${urlStart}/${pageIndex}`} index={pageIndex} isActive={true} />
      {/if}

      {#if pageIndex < pages - 1}
        <span class="flex h-10 w-10 items-center justify-center">...</span>
      {/if}
      <PageNumber href={`${urlStart}/${pages}`} index={pages} isActive={pageIndex === pages} />
    </div>

    <div class="w-[7.125rem]">
      {#if pageIndex < pages}
        <a
          href={nextUrl}
          aria-label="Next page"
          class={cn(
            "cursor-pointer rounded-md border border-blog-gray-300 px-3 py-2 text-blog-gray-500 dark:text-blog-gray-400",
            "block text-blog-gray-800",
          )}
        >
          Next&nbsp;→
        </a>
      {/if}
    </div>
  </div>
{/if}
